import { useAdminSubcategoryStore } from '@/infrastructure/store/adminSubcategoryStore';

export const useAdminSubcategories = () => {
  const store = useAdminSubcategoryStore();
  return {
    subcategories: store.subcategories,
    isLoading: store.isLoading,
    error: store.error,
    fetchSubcategories: store.fetchSubcategories,
    createSubcategory: store.createSubcategory,
    updateSubcategory: store.updateSubcategory,
    deleteSubcategory: store.deleteSubcategory,
    clearError: store.clearError,
  };
};
